export default __webpack_public_path__ + "static/media/sufiyan.3213eaf0.jpg";